const themeToCSSVariableMapper: Record<string, string[] | undefined> = {
  formInputColor: ['form-value-color'],
  errorColor: ['color-red-100'],
  secondaryColor: ['custom-heading2-color'],
  h2Color: ['custom-heading2-color'],
  h3Color: ['custom-heading3-color'],
  textColor: ['custom-content-color'],
  formLabelColor: ['form-label-color', 'custom-heading4-color'],
  primaryColor: [
    'form-value-color',
    'form-value-color-focus',
    'form-border-color-focus',
    'custom-button-bg-color',
  ],
  primaryColorDarker: ['custom-button-bg-color-hover', 'custom-button-focus-shadow'],
  buttonTextColor: ['custom-button-color'],
};

export const themeToCSSVariables = (theme: Record<string, string>) => {
  const mergedTheme = mergeOnboardingTheme(theme);

  for (const [key, value] of Object.entries(mergedTheme)) {
    if (typeof key !== 'string') continue;
    if (key.startsWith('--')) {
      // Already a CSS variable
      setCssVariable(key, value);
      continue;
    }

    const variables = themeToCSSVariableMapper[key];
    if (variables) {
      variables.forEach((variable) => setCssVariable(`--${variable}`, value));
    }
  }
};

const mergeOnboardingTheme = <T extends Record<string, string>>(theme: T): T => ({
  ...theme,
  ...(typeof theme.onboarding === 'object' ? theme.onboarding : {}),
});

const setCssVariable = (variable: string, value: string) => {
  document.documentElement.style.setProperty(variable, value);
};
